import { useDepositList } from "CRM/hooks/GetUserDeposit";
import React, { useState } from "react";
import { Blacked, DBModalContent, DBModalInput, DBModalInputLine, DepositInput, ModalHeader, ModalTitle, ModalWrapper } from "../styles";
import { Icon } from "CRM/organism/Main/styles";
import { FaChevronLeft } from "react-icons/fa6";
import { DatePicker, Input, Select, Table, message } from "antd";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/lib/locale/ko_KR";
import { AddTable, TableBtn } from "CRM/organism/Customer/styles";
import API from "utils/api";
import { useToken } from "app/hooks";
import type { DatePickerProps } from "antd";
import { useIsMobile } from "../IsMobile";

export const CustomerDeposit = ({ setIsPayment, userId, customerList, platformList }) => {
	const IsMobile = useIsMobile();
	const { data: token } = useToken();
	const { depositList, mutate } = useDepositList(userId);
	const UserName = customerList?.find((it) => it.userId == userId)?.name;
	const UserTel = customerList?.find((it) => it.userId == userId)?.tel;
	const [editId, setEditId] = useState<number>();
	const [date, setDate] = useState<Dayjs | null>(null);
	const [platform, setPlatform] = useState();
	const [amount, setAmount] = useState<string>("");
	const [isAdd, setIsAdd] = useState(false);

	const [addDate, setAddDate] = useState<Dayjs | null>(null);
	const [addPlatform, setAddPlatform] = useState(platformList?.[0]?.id);
	const [addAmount, setAddAmount] = useState<string>("");

	const deleteDeposit = (data) => {
		const shouldEdit = window.confirm(`'${data?.amount}' \n 입금기록을 삭제하시겠습니까?`);
		if (shouldEdit) {
			API.delete("/transaction/deposit?userId=" + userId + "&depositId=" + data?.id, token + "", {})
				.then((res: any) => {
					if (res.result.success) {
						message.success("삭제되었습니다");
						mutate();
					}
				})
				.catch((err: any) => {});
		}
	};

	const editDeposit = (data) => {
		const shouldEdit = window.confirm(
			` 날짜: ${dayjs(date)?.format("YYYY-MM-DD")} \n 플랫폼: ${
				platformList?.find((it) => it.id == platform)?.name
			} \n 입금액: ${amount} \n 입금기록을 수정하시겠습니까?`
		);
		if (shouldEdit) {
			API.put("/transaction/deposit?userId=" + userId + "&depositId=" + editId, token + "", {
				datas: {
					date: dayjs(date)?.format("YYYY-MM-DD"),
					platform: platform,
					amount: amount,
				},
			})
				.then((res: any) => {
					if (res.result.success) {
						message.success("수정되었습니다");
						mutate();
					}
				})
				.catch((err: any) => {});
		}
	};

	const addDeposit = () => {
		const shouldEdit = window.confirm(
			` 날짜: ${dayjs(addDate)?.format("YYYY-MM-DD")} \n 플랫폼: ${
				platformList?.find((it) => it.id == addPlatform)?.name
			} \n 입금액: ${addAmount} \n 입금기록을 등록하시겠습니까?`
		);
		if (shouldEdit) {
			API.post("/transaction/deposit?userId=" + userId, token + "", {
				date: dayjs(addDate)?.format("YYYY-MM-DD"),
				platformId: addPlatform,
				amount: addAmount,
			})
				.then((res: any) => {
					if (res.result.success) {
						message.success("등록되었습니다");
						mutate();
						setIsAdd(false);
					}
				})
				.catch((err: any) => {});
		}
	};

	const clickEdit = (data) => {
		setEditId(data?.id);
		setDate(dayjs(data?.depositedAt));
		setPlatform(data?.platformId);
		setAmount(data?.amount);
	};

	const mobileColumns = [
		{
			dataIndex: "",
			title: "결제",
			render: (value, data) => {
				return (
					<>
						<div className="checkbox" style={{ textAlign: "center", display: "flex", alignItems: "center" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>날짜:</p>
							{editId === data?.id ? (
								<DatePicker
									format={"YYYY-MM-DD"}
									value={dayjs(date, "YYYY-MM-DD")}
									onChange={(value) => setDate(value)}
								/>
							) : (
								dayjs(data?.depositedAt)?.format("YYYY-MM-DD")
							)}
						</div>
						<div className="checkbox" style={{ textAlign: "center", display: "flex", alignItems: "center" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>플랫폼:</p>
							{editId === data?.id ? (
								<Select
									value={platform}
									onChange={(e) => setPlatform(e)}
									style={{ fontFamily: "Pretendard", height: 25, margin: "5px 0" }}
								>
									{platformList?.map((it) => (
										<option style={{ fontFamily: "Pretendard" }} value={it.id}>
											{it.name}
										</option>
									))}
								</Select>
							) : (
								data?.platformName
							)}
						</div>
						<div className="checkbox" style={{ textAlign: "center", display: "flex", alignItems: "center" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>최종입금액(만원):</p>
							{editId === data?.id ? (
								<Input
									type="text"
									value={amount}
									onChange={(e) => setAmount(e.target.value)}
									placeholder="입금액을 입력해주세요."
									style={{ width: "60%" }}
								/>
							) : (
								parseFloat(data?.amount)?.toLocaleString()
							)}
						</div>
						{editId === data?.id ? (
							<div className="checkbox" style={{ textAlign: "center", display: "flex" }}>
								<TableBtn onClick={editDeposit} style={{ backgroundColor: "#437eff" }}>
									저장
								</TableBtn>
								<TableBtn onClick={() => setEditId(0)} style={{ backgroundColor: "#EF5350", marginLeft: 4 }}>
									취소
								</TableBtn>
							</div>
						) : (
							<div className="checkbox" style={{ textAlign: "center", display: "flex" }}>
								<TableBtn onClick={() => clickEdit(data)} style={{ backgroundColor: "#FFB22B" }}>
									수정
								</TableBtn>
								<TableBtn
									onClick={() => deleteDeposit(data)}
									style={{ backgroundColor: "#EF5350", marginLeft: 4 }}
								>
									삭제
								</TableBtn>
							</div>
						)}
					</>
				);
			},
		},
	];

	const columns = [
		{
			dataIndex: "checkbox",
			title: "날짜",
			render: (value, data) => {
				return (
					<div className="checkbox" style={{ textAlign: "center" }}>
						{editId == data?.id ? (
							<DatePicker
								format={"YYYY-MM-DD"}
								value={dayjs(date, "YYYY-MM-DD")}
								onChange={(value) => setDate(value)}
							/>
						) : (
							dayjs(data?.depositedAt)?.format("YYYY-MM-DD")
						)}
					</div>
				);
			},
		},
		{
			dataIndex: "checkbox",
			title: "플랫폼",
			render: (value, data) => {
				return (
					<div className="checkbox" style={{ textAlign: "center" }}>
						{editId == data?.id ? (
							<Select value={platform} onChange={(e) => setPlatform(e)} style={{ fontFamily: "Pretendard" }}>
								{platformList?.map((it) => (
									<option style={{ fontFamily: "Pretendard" }} value={it.id}>
										{it.name}
									</option>
								))}
							</Select>
						) : (
							data?.platformName
						)}
					</div>
				);
			},
		},
		{
			dataIndex: "checkbox",
			title: "최종입금액(만원)",
			render: (value, data) => {
				return (
					<div className="checkbox" style={{ textAlign: "center" }}>
						{editId == data?.id ? (
							<Input
								type="text"
								value={amount}
								onChange={(e) => setAmount(e.target.value)}
								placeholder="입금액을 입력해주세요."
							/>
						) : (
							parseFloat(data?.amount)?.toLocaleString()
						)}
					</div>
				);
			},
		},
		{
			dataIndex: "checkbox",
			title: "",
			render: (value, data) => {
				return editId == data?.id ? (
					<div className="checkbox" style={{ textAlign: "center" }}>
						<TableBtn onClick={editDeposit} style={{ backgroundColor: "#437eff" }}>
							저장
						</TableBtn>
						<TableBtn onClick={() => setEditId(0)} style={{ backgroundColor: "#EF5350", marginLeft: 4 }}>
							취소
						</TableBtn>
					</div>
				) : (
					<div className="checkbox" style={{ textAlign: "center" }}>
						<TableBtn onClick={() => clickEdit(data)} style={{ backgroundColor: "#FFB22B" }}>
							수정
						</TableBtn>
						<TableBtn onClick={() => deleteDeposit(data)} style={{ backgroundColor: "#EF5350", marginLeft: 4 }}>
							삭제
						</TableBtn>
					</div>
				);
			},
		},
	];

	const mobileAddColumns = [
		{
			dataIndex: "",
			title: "결제추가",
			render: (value, data) => {
				return (
					<>
						<div className="date" style={{ textAlign: "center", display: "flex", alignItems: "center" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>날짜:</p>
							<DatePicker format={"YYYY-MM-DD"} value={addDate} onChange={(value) => setAddDate(value)} />
						</div>
						<div
							className="platform"
							style={{ textAlign: "center", display: "flex", alignItems: "center", margin: "5px 0" }}
						>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>플랫폼:</p>
							<Select value={addPlatform} onChange={(e) => setAddPlatform(e)} style={{ fontFamily: "Pretendard" }}>
								{platformList?.map((it) => (
									<option style={{ fontFamily: "Pretendard" }} value={it.id}>
										{it.name}
									</option>
								))}
							</Select>
						</div>
						<div className="amount" style={{ textAlign: "center", display: "flex", alignItems: "center" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>최종입금액(만원):</p>
							<Input
								type="text"
								value={addAmount}
								onChange={(e) => setAddAmount(e.target.value)}
								placeholder="입금액을 입력해주세요."
								style={{ width: "60%" }}
							/>
						</div>
						<div className="checkbox" style={{ textAlign: "center", display: "flex", alignItems: "center" }}>
							<TableBtn onClick={addDeposit} style={{ backgroundColor: "#437eff" }}>
								추가
							</TableBtn>
							<TableBtn onClick={() => setIsAdd(false)} style={{ backgroundColor: "#EF5350", marginLeft: 4 }}>
								취소
							</TableBtn>
						</div>
					</>
				);
			},
		},
	];

	const addColumns = [
		{
			dataIndex: "date",
			title: "날짜",
			render: (value, data) => {
				return (
					<div className="date" style={{ textAlign: "center" }}>
						<DatePicker format={"YYYY-MM-DD"} value={addDate} onChange={(value) => setAddDate(value)} />
					</div>
				);
			},
		},
		{
			dataIndex: "platform",
			title: "플랫폼",
			render: (value, data) => {
				return (
					<div className="platform" style={{ textAlign: "center" }}>
						<Select value={addPlatform} onChange={(e) => setAddPlatform(e)} style={{ fontFamily: "Pretendard" }}>
							{platformList?.map((it) => (
								<option style={{ fontFamily: "Pretendard" }} value={it.id}>
									{it.name}
								</option>
							))}
						</Select>
					</div>
				);
			},
		},
		{
			dataIndex: "amount",
			title: "최종입금액(만원)",
			render: (value, data) => {
				return (
					<div className="amount" style={{ textAlign: "center" }}>
						<Input
							type="text"
							value={addAmount}
							onChange={(e) => setAddAmount(e.target.value)}
							placeholder="입금액을 입력해주세요."
						/>
					</div>
				);
			},
		},
		{
			dataIndex: "checkbox",
			title: "",
			render: (value, data) => {
				return (
					<div className="checkbox" style={{ textAlign: "center" }}>
						<TableBtn onClick={addDeposit} style={{ backgroundColor: "#437eff" }}>
							추가
						</TableBtn>
						<TableBtn onClick={() => setIsAdd(false)} style={{ backgroundColor: "#EF5350", marginLeft: 4 }}>
							취소
						</TableBtn>
					</div>
				);
			},
		},
	];

	return (
		<>
			<Blacked onClick={() => setIsPayment(false)} />
			{IsMobile ? (
				<ModalWrapper IsMobile={IsMobile}>
					<ModalHeader>
						<Icon onClick={() => setIsPayment(false)}>
							<FaChevronLeft />
						</Icon>
						<ModalTitle>결제관리</ModalTitle>
						<div></div>
					</ModalHeader>
					<DBModalContent style={{ border: "none" }}>
						<DBModalInputLine>
							<DepositInput>
								<label>이름</label>
								<span>{UserName}</span>
							</DepositInput>
						</DBModalInputLine>

						<DBModalInputLine style={{ marginTop: 10 }}>
							<DepositInput>
								<label>연락처</label>
								<span>{UserTel}</span>
							</DepositInput>
						</DBModalInputLine>
						<Table style={{ marginTop: 10 }} dataSource={depositList} columns={mobileColumns} bordered={true} />
						{isAdd ? (
							<AddTable
								style={{ marginTop: 10 }}
								dataSource={[{ date: addDate, platform: addPlatform, amount: addAmount }]}
								columns={mobileAddColumns}
							/>
						) : (
							<DepositInput style={{ justifyContent: "flex-end", marginTop: 20 }}>
								<TableBtn className="addPay" onClick={() => setIsAdd(true)}>
									결제추가
								</TableBtn>
							</DepositInput>
						)}
					</DBModalContent>
				</ModalWrapper>
			) : (
				<ModalWrapper style={{ width: 600 }}>
					<ModalHeader>
						<Icon onClick={() => setIsPayment(false)}>
							<FaChevronLeft />
						</Icon>
						<ModalTitle>결제관리</ModalTitle>
						<div></div>
					</ModalHeader>
					<DBModalContent style={{ border: "none" }}>
						<DBModalInputLine>
							<DepositInput>
								<label>이름</label>
								<span>{UserName}</span>
							</DepositInput>
							<DepositInput>
								<label>연락처</label>
								<span>{UserTel}</span>
							</DepositInput>
						</DBModalInputLine>
						<Table style={{ marginTop: 10 }} dataSource={depositList} columns={columns} />
						{isAdd ? (
							<AddTable
								style={{ marginTop: 10 }}
								dataSource={[{ date: addDate, platform: addPlatform, amount: addAmount }]}
								columns={addColumns}
							/>
						) : (
							<DepositInput style={{ justifyContent: "flex-end", marginTop: 20 }}>
								<TableBtn className="addPay" onClick={() => setIsAdd(true)}>
									결제추가
								</TableBtn>
							</DepositInput>
						)}
					</DBModalContent>
				</ModalWrapper>
			)}
		</>
	);
};

export default React.memo(CustomerDeposit);
